export const DISABILITY_SLIDER_STEP = 10_000;
export const CONTACT_ADVISOR_MIN_CAPITAL_DIFF = 100_000;
export const DISABILITY_CAPITAL_DOCUMENTATION_THRESHOLD = 2_000_000;
